import { BaseHeaderLinkDefinition, HeaderLinkType, ViewHeaderLinkDefinition } from '@msdk/definitions'
import React, { ReactElement } from 'react'

import { ViewLink } from './Links'

interface Props {
  link: BaseHeaderLinkDefinition
  reload: () => void
}

export function ConditionalLinkRenderer(props: Props) {
  const renderer: Record<HeaderLinkType, ReactElement> = {
    View: <ViewLink link={props.link as ViewHeaderLinkDefinition} reload={props.reload} />,
  }

  return <>{renderer[props.link.type]}</>
}
